export default __webpack_public_path__ + "static/media/004-wine.ae26bd87.svg";